import { useContext, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  AttachMoney,
  Build,
  CompareArrows,
  Inventory,
  Link,
  MoreHoriz,
  ShoppingCart,
  VpnKey,
} from '@mui/icons-material';
import {
  Box,
  Collapse,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Switch,
  Tab,
  Tabs,
} from '@mui/material';
import { DropsContext } from 'contexts/DropsContext';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import styles from './styles';

const Amazon = ({ logo, loading, integracao, handleAuth, handleSave }) => {
  const [tab, setTab] = useState(0);
  const access_data = integracao?.access_data;
  const defaultValues = {
    id: integracao?.id,
    //ACESSO
    nome_integracao: access_data?.nome_integracao || '',
    //ACOES
    importar_pedidos: access_data?.importar_pedidos || false,
    importar_anuncios: access_data?.importar_anuncios || false,
    importar_nf: access_data?.importar_nf || false,
    enviar_nf: access_data?.enviar_nf || false,
    indica_expedicao: access_data?.indica_expedicao || false,
    indica_expedicao: access_data?.indica_expedicao || false,
    gerar_nf: access_data?.gerar_nf || false,
    transmitir_nf: access_data?.transmitir_nf || false,
    serie_id: access_data?.serie_id || false,
    sincronizar_estoque: access_data?.sincronizar_estoque || false,
    sincronizar_anuncios: access_data?.sincronizar_anuncios || false,
    update_preco: access_data?.update_preco || false,
    //CONCILIACAO
    plano_venda: access_data?.plano_venda || null,
    plano_venda_full: access_data?.plano_venda_full || null,
    plano_devolucao_full: access_data?.plano_devolucao_full || null,
    plano_frete: access_data?.plano_frete || null,
    plano_tarifa: access_data?.plano_tarifa || null,
    //PRODUTOS
    order_product_search_field: access_data?.order_product_search_field || null,
    //FINANCEIRO
    cxconta_id: access_data?.cxconta_id || null,
    forma_pagto_id: access_data?.forma_pagto_id || null,
    //VENDA
    vendedor_id: access_data?.vendedor_id || null,
    filial_id: access_data?.filial_id || null,
    separate_kit: access_data?.separate_kit || null,
    //OUTROS
    user_notification: access_data?.user_notification || null,
    celocal_id: access_data?.celocal_id || null,
    impressora_id: access_data?.impressora_id || null,
  };
  const { drops } = useContext(DropsContext);
  const { control, handleSubmit, watch } = useForm({ defaultValues });
  const transmitir_nf = watch('transmitir_nf');

  return (
    <Container>
      <Header titulo="Configurações" />
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Box sx={styles?.header}>
            <Box
              src={logo}
              component="img"
              sx={styles?.img}
              alt={integracao?.api}
            />
            <Tabs value={tab} onChange={(_, v) => setTab(v)}>
              <Tab
                value={0}
                icon={<VpnKey />}
                iconPosition="start"
                label="Acesso"
              />
              <Tab
                value={1}
                icon={<Build />}
                iconPosition="start"
                label="Ações"
              />
              <Tab
                value={2}
                icon={<CompareArrows />}
                iconPosition="start"
                label="Conciliação"
              />
              <Tab
                value={3}
                icon={<Inventory />}
                iconPosition="start"
                label="Produto"
              />
              <Tab
                value={4}
                icon={<AttachMoney />}
                iconPosition="start"
                label="Financeiro"
              />
              <Tab
                value={5}
                icon={<ShoppingCart />}
                iconPosition="start"
                label="Venda"
              />
              <Tab
                value={6}
                icon={<MoreHoriz />}
                iconPosition="start"
                label="Outros"
              />
            </Tabs>
          </Box>
        </Grid>
        <Grid item xs={12} display={tab === 0 ? 'block' : 'none'}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button
                color="primary"
                loading={loading}
                variant="outlined"
                startIcon={<Link />}
                onClick={handleAuth}
              >
                Autenticar Integração
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Input
                control={control}
                name="nome_integracao"
                label="Nome da Integração"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} display={tab === 1 ? 'block' : 'none'}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Controller
                name="importar_pedidos"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Importar e Atualizar Pedidos"
                    control={
                      <Switch
                        {...field}
                        checked={field?.value}
                        onChange={(e) => field?.onChange(e?.target?.checked)}
                      />
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="importar_anuncios"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Importar e Atualizar Anúncios"
                    control={
                      <Switch
                        {...field}
                        checked={field?.value}
                        onChange={(e) => field?.onChange(e?.target?.checked)}
                      />
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="importar_nf"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Importar NF das Vendas Feitas Pelo Full"
                    control={
                      <Switch
                        {...field}
                        checked={field?.value}
                        onChange={(e) => field?.onChange(e?.target?.checked)}
                      />
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="gerar_nf"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Gerar NF do Pedido automaticamente"
                    control={
                      <Switch
                        {...field}
                        checked={field?.value}
                        onChange={(e) => field?.onChange(e?.target?.checked)}
                      />
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="transmitir_nf"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Transmitir NF gerada automaticamente para a SEFAZ"
                    control={
                      <Switch
                        {...field}
                        checked={field?.value}
                        onChange={(e) => field?.onChange(e?.target?.checked)}
                      />
                    }
                  />
                )}
              />
              <Collapse in={!!transmitir_nf}>
                <Box mt={2} maxWidth={400}>
                  <Dropdown
                    control={control}
                    name="serie_id"
                    label="Série da NF"
                    options={drops?.Serie}
                  />
                </Box>
              </Collapse>
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="enviar_nf"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Enviar NF dos Pedidos ao Marketplace após Transmitir"
                    control={
                      <Switch
                        {...field}
                        checked={field?.value}
                        onChange={(e) => field?.onChange(e?.target?.checked)}
                      />
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="indica_expedicao"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Indicar Expedição das Notas após envio ao Marketplace"
                    control={
                      <Switch
                        {...field}
                        checked={field?.value}
                        onChange={(e) => field?.onChange(e?.target?.checked)}
                      />
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="sincronizar_estoque"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Sincronizar Estoque Quando Houver Movimentação de Estoque do Produto Anunciado"
                    control={
                      <Switch
                        {...field}
                        checked={field?.value}
                        onChange={(e) => field?.onChange(e?.target?.checked)}
                      />
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="sincronizar_anuncios"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Sincronizar Anúncios Quando Houver Alteração do Produto"
                    control={
                      <Switch
                        {...field}
                        checked={field?.value}
                        onChange={(e) => field?.onChange(e?.target?.checked)}
                      />
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="update_preco"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Sincronizar o Preço do Anúncio ao Atualizar o Preço do Produto"
                    control={
                      <Switch
                        {...field}
                        checked={field?.value}
                        onChange={(e) => field?.onChange(e?.target?.checked)}
                      />
                    }
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} display={tab === 2 ? 'block' : 'none'}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Dropdown
                control={control}
                name="plano_venda"
                label="Plano de Contas de Vendas"
                options={drops?.Planoconta?.filter(
                  (p) => p?.operacional === 'SIM'
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                control={control}
                name="plano_venda_full"
                label="Plano de Contas de Vendas do Full"
                options={drops?.Planoconta?.filter(
                  (p) => p?.operacional === 'SIM'
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                control={control}
                name="plano_devolucao_full"
                label="Plano de Contas de Devolução do Full"
                options={drops?.Planoconta?.filter(
                  (p) => p?.operacional === 'SIM'
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                control={control}
                name="plano_frete"
                label="Plano de contas de Frete"
                options={drops?.Planoconta?.filter(
                  (p) => p?.operacional === 'SIM'
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                control={control}
                name="plano_tarifa"
                label="Plano de contas de Tarifas"
                options={drops?.Planoconta?.filter(
                  (p) => p?.operacional === 'SIM'
                )}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} display={tab === 3 ? 'block' : 'none'}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Referenciar SKU do Produto na Amazon por:</FormLabel>
                <Controller
                  name="order_product_search_field"
                  control={control}
                  render={({ field }) => (
                    <RadioGroup {...field} sx={styles?.group}>
                      <FormControlLabel
                        value="id"
                        control={<Radio />}
                        label="ID"
                      />
                      <FormControlLabel
                        value="referencia"
                        control={<Radio />}
                        label="Referência"
                      />
                    </RadioGroup>
                  )}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} display={tab === 4 ? 'block' : 'none'}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Dropdown
                name="cxconta_id"
                control={control}
                label="Conta Bancária"
                options={drops?.Cxconta}
              />
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                control={control}
                name="forma_pagto_id"
                label="Forma de Pagamento"
                options={drops?.FormaDePagamento}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} display={tab === 5 ? 'block' : 'none'}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Dropdown
                label="Vendedor"
                control={control}
                name="vendedor_id"
                options={drops?.EntidadeTipo?.filter((t) =>
                  ['VENDEDOR', 'REPRESENTANTE']?.includes(t?.tipo)
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                label="Filial"
                control={control}
                name="filial_id"
                options={drops?.EntidadeTipo?.filter(
                  (t) => t?.tipo === 'FILIAL'
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="separate_kit"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Importar itens pela estrutura do produto"
                    control={
                      <Switch
                        {...field}
                        checked={field?.value}
                        onChange={(e) => field?.onChange(e?.target?.checked)}
                      />
                    }
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} display={tab === 6 ? 'block' : 'none'}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Dropdown
                control={control}
                options={drops?.Users}
                name="user_notification"
                label="Usuário para Receber Notificações"
              />
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                control={control}
                name="celocal_id"
                options={drops?.LocalEstoque}
                label="Local de Estoque a Movimentar"
              />
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                control={control}
                name="impressora_id"
                options={drops?.Impressoraweb}
                label="Impressora de Etiqueta de Expedição"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box sx={styles?.bottom}>
        <Button
          color="primary"
          loading={loading}
          variant="contained"
          onClick={handleSubmit(handleSave)}
        >
          Salvar
        </Button>
      </Box>
    </Container>
  );
};

export default Amazon;
